<template>
    <div class="phhonor ph-big-star">
        <el-backtop ></el-backtop>
        <hpheader></hpheader>

        <div class="position-bar-container">
            <position-bar :positionNav="positionNav">
            </position-bar>
        </div>

        <div class="phanew-cont">
            <div class="phnewcontss">
                <div class="phnew-item" v-for="(item,index) in videos.list">
                    <div class="phnewitem-img ph-big-star-video">
<!--                        <myVideo ref="myVideo" :src="item.video" :poster="item.poster"></myVideo>-->
<!--                        <div class="poster" v-if="!item.isPlay" @click="playVideo(item)">-->
<!--                            <img class="play" src="../../assets/common/img/play.png" alt="">-->
<!--                            <img :src="item.poster" alt="" >-->
<!--                        </div>-->
<!--                        <iframe v-else class="you-video" :src="item.video" :title="item.en_title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>-->
                        <div class="poster"  @click="learnMore(item)">
                            <img class="play" src="../../assets/common/img/play.png" alt="">
                            <img :src="item.poster" alt="" >
                        </div>
                    </div>
                    <div class="phnew-item-text">
                        <div class="phnew-name" @click="learnMore(item)">
                            {{item.title}}
                        </div>
                    </div>
                    <!--                    <div class="phnew-title">{{item.mark}}</div>-->
                </div>
<!--                <div class="phnew-more" v-if="morenew">-->
<!--                    <div class="phnewcont" @click="newmore()">-->
<!--                        加载更多-->
<!--                        <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/phquerysimg/phqueryfooxia.png" />-->
<!--                    </div>-->
<!--                </div>-->
                <div ref="bottom" class="bottom" >
                </div>
            </div>
        </div>
        <hpfooter></hpfooter>
    </div>
</template>

<script>
    import hpheader from '../../common/hpheader.vue'
    import hpfooter from '../../common/hpfooter.vue'
    import {session} from "../../storage/storage";
    import positionBar from '../../components/ph-position-bar.vue'
    import myVideo from '../../common/myvideo/img/myVideo.vue'
    import utils from '../../api/utils.js'


    export default{
        data(){
            return{
                info:{},
                newacti:2,
                newsize:5,
                morenew:true,
                newnav:1,
                pcnewtyp:[],
                newlists:[],
                imgHeight: '',
                positionNav:[
                    {
                        title:'Home',
                        path:'/phhome',
                    },
                    {
                        title:'Top Talk',
                        path:'',
                    },
                ],
                bigStar:[ ],
                videos:{
                    list:[],
                    page:{
                        current_page:1,
                        last_page:1
                    },
                    loading:false
                }
            }
        },
        created() {
            window.scrollTo(0,0);
            this.ress()
            this.pcnewtype()
            // this.pcnewlist();
            this.pageParam()


            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })

            if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
                this.$router.push({path:'pc-big-star'})
                return
            }
            this.getBigStarList()

        },
        mounted(){
            // this.slideBanner()
        },
        components:{
            hpfooter,
            hpheader,
            positionBar,
            myVideo
        },
        methods:{
            learnMore(item){
                window.open(utils.getYouUrl(item.video_id))
            },
            playVideo(item){
                item.isPlay = true
                item.video = this.getYouUri(item.video_id)
                this.$forceUpdate()
            },
            getYouUri(videoId){
                return utils.getYouUri(videoId)
            },
                handleScroll () {
                    if(!this.$utils.isElementNotInViewport(this.$refs.bottom)){
                        if(this.videos.loading){
                            return
                        }
                        this.videos.loading = true
                        this.videos.page.current_page ++
                        this.getBigStarList()
                    }
                },
                getBigStarList(){
                this.$api.get_big_star_list({
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    page:this.videos.page.current_page,
                }).then(res => {
                    this.videos.list = this.videos.list.concat(res.data.data)
                    this.videos.page.current_page = res.data.current_page
                    this.videos.page.last_page = res.data.last_page
                    this.videos.loading = this.videos.page.current_page >= this.videos.page.last_page ? true : false
                    // this.videos.list.map((v,i) => {
                    //     v.option = this.makePlayerOptions(v)
                    //     this.$set(v,'playVideo',false)
                    //     this.$set(v,'first',true)
                    // })
                })
            },
            imgLoad() {
                // 获取图片高度
                this.$nextTick(() => {
                    this.imgHeight = this.$refs.imgHeight['0'].height + 'px'
                })
            },
            newmore(){
                this.newsize+=5
                this.pcnewlist()
            },
            navnewdetail(e){
                let typeid=this.newnav
                this.$router.push({path: '/ph-news-detail',query:{e,typeid}});
            },
            newnavcli(e){
                this.newacti=e
                this.newnav = e
                this.pcnewlist()
            },
            pcnewtype(){
                let data={
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold:'h5',
                }
                this.$api.get_new_type(data).then((res) => {
                    this.pcnewtyp=res.data
                    if(res.data.length>0){
                        this.newnavcli(res.data[0].id)
                    }
                    console.log(this.pcnewtyp)
                });
            },
            pcnewlist(){
                let data={
                    type_id:this.newnav,
                    lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
                    channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
                    mold:'h5',
                    page:'1',
                    pageSize:this.newsize,
                }
                this.$api.get_new_list(data).then((res) => {
                    this.newlists=res.data
                    console.log(this.newlists)
                    if(this.newsize>this.newlists.length){
                        this.morenew=false
                    }


                });
            },
            pageParam(){
                let lang =  session.get("lang");
                if (lang === "cn"){
                    this.leftuscreated =  [
                        {'ustitle':'我们的核心价值观','usmintitle':'认真、诚信、感恩'},
                        {'ustitle':'我们的作风','usmintitle':'想就有办法，做就做第一快、准、狠'},
                    ]
                    this.rightuscreated =  [
                        {'ustitle':'我们的准则','usmintitle':'忠诚、认真、专业、创新、追求卓越以客户为核心,一切为客户而改变'},
                        {'ustitle':'我们的愿景','usmintitle':'创世界一流企业，当中国起先锋,赢得全球客户的尊重和信赖，实现啄木鸟人的，梦想'},

                    ]
                    this.year = "年"
                    this.info = {
                        'about': "关于啄木鸟",
                        'around': "公司环境",
                        'honor': '公司荣誉',
                        'news' : '新闻中心',
                        'course' : '公司历程',
                        'more' : "显示更多",
                        'special': '专题',
                    }
                }else{
                    this.created = "Woodpecker creation"
                    this.leftuscreated =  [
                        {'ustitle':'Our core values','usmintitle':'Earnest, honest and grateful'},
                        {'ustitle':'Our style','usmintitle':'Think there is a way, do it first, fast, accurate and obscene'},
                    ]
                    this.rightuscreated =  [
                        {'ustitle':'Our guidelines','usmintitle':'Loyal, serious, professional, innovative, pursuing excellence, taking customers as the core and changing everything for customers'},
                        {'ustitle':'Our vision','usmintitle':'Create a world-class enterprise, be a pioneer in China, win the respect and trust of global customers, and realize the dream of woodpecker'},
                    ]
                    this.year = "year"
                    this.info = {
                        'about': "About woodpecker",
                        'around': "Company environment",
                        'honor': 'Company honor',
                        'news' : 'News Center',
                        'course' : 'Company history',
                        'more' : "More",
                        'special': 'Special',
                    }

                }
            },
            ress(){
                var html = document.documentElement; //获取根元素
                var designWidth = 750; //设计稿宽度
                //html.clientWidth 视口宽度
                html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
            },

        }
    }
</script>

<style>
    body{
        margin: 0;
        padding: 0;
    }

    .phhonor{
        background: #FFF;
        padding-top: 0.88rem;
    }
    .phhonor-hea{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 7.5rem;
        height: 0.88rem;
        background: #FFFFFF;
    }
    .phhonorhea-left{
        margin-left: 0.3rem;
        width: 0.97rem;
        height: 0.5rem;
    }
    .phhonorhea-left img{
        width: 100%;
        height: 100%;
    }
    .phhonorhea-right{
        margin-right: 0.3rem;
        width: 0.38rem;
        height: 0.38rem;
    }
    .phhonorhea-right img{
        width: 100%;
        height: 100%;
    }
    .phvir-hea{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.36rem;
        font-weight: 600;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
    }
    .phnewsnav-con{
        display: flex;
        flex-wrap: nowrap;
        overflow: auto;
        margin-left: 0.3rem;
    }
    .phnewsnavcoont-item{
        min-width: 1.2rem;
        text-align: center;
        margin-right: 0.32rem;
        font-size: 0.28rem;
        font-weight: 400;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        margin-bottom: 0.4rem;
    }
    .phnewitem-img{
        border-radius: 0.06rem;
    }
    .phnewitem-img img{
        display: block;
        width: 100%;
    }
    .phnewcontss{
        margin-bottom: 0.6rem;
        margin-top: .3rem;
        padding: 0 .3rem;
    }
    .phnew-item-text {
        padding: .4rem;
    }
    .phnew-time{
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        font-weight: 400;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
        margin-top: 0.2rem;
    }
    .neewhealc{
        color: #D03E3D;
    }
    .phnewtime-left{
        width: 1rem;
        height: 0.4rem;
        background: #D03E3D;
        border-radius: 0.05rem;
        font-size: 0.24rem;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 0.01rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.2rem;
    }
    .phnew-name{
        font-size: 0.32rem;
        font-weight: bold;
        color: #5d5f5f;
        letter-spacing: 0.01rem;
    }
    .phnew-title{
        font-size: 0.24rem;
        font-weight: 500;
        color: #999999;
        letter-spacing: 0.01rem;
        margin-top: 0.17rem;
    }
    /*.phnew-item{*/
    /*    margin-bottom: 0.5rem;*/
    /*    box-shadow: 0 .1rem .2rem 0 rgba(0,0,0,.1);*/
    /*    border-radius: 10px;*/
    /*}*/
    .phnews-nav{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.4rem;
    }
    .phnew-more{
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .phnew-more img{
        width: 0.3rem;
        height: 0.3rem;
    }
    .phnewcont{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1.7rem;
        height: 0.5rem;
        border-radius: 0.06rem;
        border: 0.01rem solid #999;
        font-size: 0.28rem;
        color: #999;
        margin-bottom: 0.3rem;
    }

    .ph-big-star {

    }

    .ph-big-star-video {}
    .ph-big-star-video .video {
        width: 100%;
    }

    .ph-big-star .phnew-item {
        border-radius: 20px;
        margin-bottom: 0.5rem;
        box-shadow: 0 .1rem .2rem 0 rgba(0,0,0,.1);
        overflow: hidden;
    }
    .ph-big-star .you-video {
        display: block;
        width: 100%;
        height: 800px;
    }
    .ph-big-star .poster {
        position: relative;
    }
    .ph-big-star .poster .play{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 200px;
        height: 200px;
        transform: translate(-50%,-50%);
    }
</style>
